module.exports = __webpack_public_path__ + "img/icon_map_10_on_100.2238c7d1.png";